import script from "./OrderProcessed.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderProcessed.vue?vue&type=script&setup=true&lang=ts"

import "./OrderProcessed.vue?vue&type=style&index=0&id=5a5dcc5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5dcc5d"]])

export default __exports__